import { useDispatch } from 'react-redux';

import { loadProvider, uploadProviderAvatar } from 'actions/provider';
import ImageUploader from 'atoms/image-uploader';
import useWindowDimensions from 'hooks/useWindowDimensions';

export default function ProviderTitle({ isMyProvider, provider }) {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  const location = provider?.locations?.[0];
  const avatar = location?.links?.image?.desktop?.small;
  const name = location?.name;
  const type = location?.type?.map((el) => el.value).join(', ');

  const editImage = (image) => {
    dispatch(uploadProviderAvatar(image)).then(({ success }) => {
      if (success) {
        dispatch(loadProvider());
      }
    });
  };

  return (
    <div className="provider-title">
      <div className="avatar-section">
        <ImageUploader
          fileName="upload_file"
          showEditIcon={isMyProvider}
          saveImage={editImage}
          avatar={avatar}
          placeholder="pawFilled"
          variant="profile"
          size={isMobile ? 'small-medium' : 'medium'}
        />
      </div>
      <div className="flex-column">
        <h2>{name}</h2>
        <p>{type}</p>
      </div>
    </div>
  );
}
